import { useState } from "react"
import { studentRequest } from "services/requests"
import { useGlobalAlert } from "contexts/GlobalAlertContext"
import { isRunningFromIframe } from "common/functions"
import secureLocalStorage from "react-secure-storage"
import { t } from "i18next"
const FormData = require("form-data")
const prefix = "grades"
const sendFormData = studentRequest.sendFormData

const useApi = () => {
  const [isFetching, setIsFetching] = useState(false)
  const { showAlert } = useGlobalAlert()

  const updateGrade = async ({ grade, gradeId, comment, audioFile }) => {
    setIsFetching(true)
    const data = new FormData()
    data.append("grade", grade)
    data.append("gradeId", gradeId)
    data.append("comment", comment)
    if (audioFile) {
      data.append("audioFile", audioFile)
    }
    let parentToken
    try {
      const runningFromIframe = isRunningFromIframe()
      if (runningFromIframe) {
        parentToken = window?.parent?.getToken()
      } else {
        parentToken = secureLocalStorage.getItem("smashAuthToken")
      }
    } catch (error) {}
    const response = await sendFormData({
      endpoint: `${prefix}/teacher/update`,
      formData: data,
      headers: {
        Authorization: parentToken,
      },
    })
    if (!response.success) showAlert(t(response.message))
    setIsFetching(false)
    return response.data
  }

  return {
    updateGrade,
    isFetching,
  }
}

export default useApi
